import React from 'react';
import * as R from 'ramda';
import * as Yup from 'yup';
import { withFormik } from 'formik';
import { pure, compose } from 'react-recompose';
// components
import { FormFooter } from '../../../components/form-footer';
// helpers/constants
import * as G from '../../../helpers';
import * as GC from '../../../constants';
// forms
import { Fieldset2 } from '../../../forms';
// feature master-invoice
import { getFields, defaultValues, getValidationSchema } from '../settings/print-formik-settings';
//////////////////////////////////////////////////

const enhance = compose(
  withFormik({
    enableReinitialize: true,
    mapPropsToValues: ({ initialValues }) => G.setInitialFormikValues(
      defaultValues,
      initialValues,
    ),
    validationSchema: ({ templateOptions }) => Yup.lazy((values) => (
      Yup.object().shape(getValidationSchema(values, templateOptions))
    )),
    handleSubmit: (values, { props }) => {
      const { sendEmails, useExcelExport } = values;

      const { submitAction } = props;

      let fieldsToOmit = sendEmails ?
        [GC.FIELD_SEND_EMAILS] :
        [GC.FIELD_EMAILS, GC.FIELD_SEND_EMAILS, GC.FIELD_MAIL_SENDING_REPLY_TO];

      if (useExcelExport) {
        fieldsToOmit = [...fieldsToOmit, 'useExcelExport'];
      } else {
        fieldsToOmit = [...fieldsToOmit, 'excelExport', 'useExcelExport'];
      }

      submitAction(R.omit(fieldsToOmit, values));
    },
    displayName: 'PRINT_OPTIONS_FORM',
  }),
  pure,
);

const PrintOptionsForm = (props) => {
  const {
    handleSubmit,
    templateOptions,
    useVendorDocuments,
    documentTypeOptions,
    vendorDocumentTypeOptions,
    availableCustomExportOptions,
  } = props;

  const optionsForSelect = {
    templateOptions,
    documentTypeOptions,
    vendorDocumentTypeOptions,
    availableCustomExportOptions,
  };

  return (
    <form onSubmit={handleSubmit}>
      <Fieldset2
        {...optionsForSelect}
        {...G.getFormikProps(props)}
        fieldsWrapperStyles={{ mt: 15 }}
        fields={getFields(useVendorDocuments)}
        additionFieldComponentProps={['availableCustomExportOptions']}
      />
      <FormFooter />
    </form>
  );
};

export default enhance(PrintOptionsForm);
